import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
//Material
import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  styled,
  TextField,
  Typography
} from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import InputMask from 'react-input-mask';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { LetsGoBtn, LetsGoBtn3 } from '../../components/Buttons';
import Page from '../../components/Page';
import ServiceCardOrder from '../../components/ServiceCardOrder';
import { Spinner } from '../../components/Spinner';
import { StyledTitle } from '../../components/StyledComponents';
import ApiService from '../../helpers/apiHelper';
import { UACities } from '../../services/UACIties';
import '../MainPage/index.css';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF !important',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C !important',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function OrderPage({ language, userData, blockedUsers, usersWhoBlocked }) {
  const apiService = new ApiService('posts/service');
  const apiOrderCreate = new ApiService('posts/order/create');
  const apiMake = new ApiService('posts/payments/get-signature');
  // const apiMake = new ApiService('/payments/get-signature');
  // const apiService = new ApiService('service');
  // const apiOrderCreate = new ApiService('/order/create');

  const params = useParams();
  const navigate = useNavigate();
  // eslint-disable-next-line
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const [stage, setStage] = useState(0);
  const [cities, setCities] = useState([]);
  // eslint-disable-next-line
  const [departments, setDepartments] = useState([]);
  const [service, setService] = useState(null);
  const [isLoading, setIsLoadiang] = useState(false);
  const makeSafeOrder = (data) => {
    const newWindow = window.open('', '_blank');
    apiMake
      .postDataQueryBody(
        { isSave: false },
        {
          ...data
        }
      )
      .then((res) => {
        const url = res?.invoiceUrl;
        if (!url || !newWindow) return;
        newWindow.location.href = url;
      })
      .catch((error) => {
        console.error(error);
        if (newWindow) {
          newWindow.close();
        }
      });
  };
  const dataSetter = () => {
    setIsLoadiang(true);

    apiService
      .getItemById(params.id)
      .then((res) => {
        if (
          res.result?.availability !== 'Немає в наявності' &&
          res.result?.userDTO?.id !== userData?.id &&
          !blockedUsers.find((el) => el?.id === res.result?.userDTO?.id)
        ) {
          setService(res.result);
          setIsLoadiang(false);
        } else {
          navigate(-1);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error?.message && error?.message.includes("Can't get service post")) {
          navigate('/ua');
        }
        if (error?.message && error?.message.includes('Service with serviceId')) {
          navigate('/ua');
        }
      });
  };
  const schema = Yup.object().when((values, schema) => {
    if (values.deliveryType === "Кур'єр") {
      return schema.shape({
        buyerName: Yup.string()
          .max(100, 'Максимально 100 символів')
          .min(2, 'Мінімально 2 символи')
          .required("Це поле обов'язкове"),
        buyerSurname: Yup.string()
          .max(100, 'Максимально 100 символів')
          .min(2, 'Мінімально 2 символи')
          .required("Це поле обов'язкове"),
        buyerNumber: Yup.string()
          .min(13, 'Введіть коректний номер телефону')
          .required("Це поле обов'язкове"),
        region: Yup.object().required("Це поле обов'язкове"),
        city: Yup.string().required("Це поле обов'язкове"),
        street: Yup.string()
          .max(256, 'Максимально 256 символів')
          .min(2, 'Мінімально 2 символи')
          .required("Це поле обов'язкове"),
        houseNumber: Yup.string()
          .max(5, 'Максимально 5 символів')
          .min(1, 'Мінімально 1 символи')
          .required("Це поле обов'язкове"),
        paymentType: Yup.string().required('Потрібно обрати хочаб один варінт'),
        deliveryType: Yup.string().required('Потрібно обрати хочаб один варінт'),
        comment: Yup.string().max(150, 'Максимально 150 символів')
      });
    } else {
      return schema.shape({
        buyerName: Yup.string()
          .max(100, 'Максимально 100 символів')
          .min(2, 'Мінімально 2 символи')
          .required("Це поле обов'язкове"),
        buyerSurname: Yup.string()
          .max(100, 'Максимально 100 символів')
          .min(2, 'Мінімально 2 символи')
          .required("Це поле обов'язкове"),
        buyerNumber: Yup.string()
          .min(13, 'Введіть коректний номер телефону')
          .required("Це поле обов'язкове"),
        city: Yup.string().required("Це поле обов'язкове"),
        paymentType: Yup.string().required('Потрібно обрати хочаб один варінт'),
        deliveryType: Yup.string().required('Потрібно обрати хочаб один варінт'),
        comment: Yup.string().max(150, 'Максимально 150 символів'),
        department: Yup.string().required("Це поле обов'язкове")
      });
    }
  });

  const formik = useFormik({
    initialValues: {
      buyerName: userData?.name ? userData.name : '',
      buyerSurname: userData?.surname ? userData.surname : '',
      buyerNumber: userData?.number ? userData.number : '',
      qty: 1,
      region: '',
      city: '',
      street: '',
      houseNumber: '',
      paymentType: '',
      // service?.paymentOption && service?.paymentOption.length !== 0
      //   ? service?.paymentOption[0]
      //   : '',
      deliveryType: '',
      // service?.deliveryOption && service?.deliveryOption.length !== 0
      //   ? service?.deliveryOption[0]
      //   : '',
      comment: '',
      department: ''
    },
    enableReinitialize: true,
    validationSchema: schema,
    // eslint-disable-next-line
    onSubmit: (values, { resetForm, setErrors }) => {
      if (values?.paymentType !== 'Безпечна оплата') {
        setIsLoadiang(true);
        apiOrderCreate
          .sendRequest(
            values?.deliveryType === "Кур'єр"
              ? {
                  serviceId: service?.id,
                  qty: values.qty,
                  contact: `${values.buyerName} ${values.buyerSurname} ${values.buyerNumber}`,
                  deliveryType: `${values.deliveryType}, ${
                    values?.city && values?.city.length !== 0 ? `н.п.${values?.city}, ` : ''
                  }${
                    values?.region && values?.region?.region && values?.region?.region.length !== 0
                      ? `${values?.region?.region} обл., `
                      : ''
                  }${
                    values?.department && values?.department.length !== 0
                      ? `Відділення ${values?.department},`
                      : ''
                  }${
                    values?.street && values?.street.length !== 0 ? `вул.${values?.street}, ` : ''
                  }${
                    values?.houseNumber && values?.houseNumber.length !== 0
                      ? `буд.${values?.houseNumber}`
                      : ''
                  }`,
                  paymentType: values.paymentType,
                  comment: values.comment,
                  price: (+service.price * values.qty).toFixed(2)
                  // recipientCityRef: 'string',
                  // recipientWarehouseRef: 'string'
                }
              : {
                  serviceId: service?.id,
                  qty: values.qty,
                  contact: `${values.buyerName} ${values.buyerSurname} ${values.buyerNumber}`,
                  deliveryType: `${values.deliveryType}, ${
                    values?.city && values?.city.length !== 0 ? `н.п.${values?.city}, ` : ''
                  }${
                    values?.region && values?.region?.region && values?.region?.region.length !== 0
                      ? `${values?.region?.region} обл., `
                      : ''
                  }${
                    values?.department && values?.department.length !== 0
                      ? `Відділення ${values?.department}`
                      : ''
                  }`,
                  paymentType: values.paymentType,
                  comment: values.comment,
                  price: (+service.price * values.qty).toFixed(2)
                  // recipientCityRef: 'string',
                  // recipientWarehouseRef: 'string'
                }
          )
          .then((res) => {
            setStage(1);
            setIsLoadiang(false);
          })
          .catch((error) => console.error(error));
      } else {
        setIsLoadiang(true);
        // dispatch(
        //   setIsOpenServiceOrderModal({
        //     isOpen: true,
        //     data: {
        //       serviceId: service?.id,
        //       qty: values.qty,
        //       contact: `${values.buyerName} ${values.buyerSurname} ${values.buyerNumber}`,
        //       deliveryType: `${values.deliveryType}, ${
        //         values?.city && values?.city.length !== 0 ? `н.п.${values?.city}, ` : ''
        //       }${
        //         values?.region && values?.region?.region && values?.region?.region.length !== 0
        //           ? `${values?.region?.region} обл., `
        //           : ''
        //       }${
        //         values?.department && values?.department.length !== 0
        //           ? `Відділення ${values?.department}`
        //           : ''
        //       }`,
        //       paymentType: values.paymentType,
        //       comment: values.comment,
        //       price: (+service.price * values.qty).toFixed(2)
        //       // recipientCityRef: 'string',
        //       // recipientWarehouseRef: 'string'
        //     }
        //   })
        // );
        makeSafeOrder({
          serviceId: service?.id,
          qty: values.qty,
          contact: `${values.buyerName} ${values.buyerSurname} ${values.buyerNumber}`,
          deliveryType: `${values.deliveryType}, ${
            values?.city && values?.city.length !== 0 ? `н.п.${values?.city}, ` : ''
          }${
            values?.region && values?.region?.region && values?.region?.region.length !== 0
              ? `${values?.region?.region} обл., `
              : ''
          }${
            values?.department && values?.department.length !== 0
              ? `Відділення ${values?.department}`
              : ''
          }`,
          paymentType: values.paymentType,
          comment: values.comment,
          price: (+service.price * values.qty).toFixed(2)
          // recipientCityRef: 'string',
          // recipientWarehouseRef: 'string'
        });
      }
    }
  });
  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    submitForm,
    setErrors,
    setTouched,
    // eslint-disable-next-line
    resetForm,
    setFieldValue
  } = formik;

  useEffect(() => {
    if (blockedUsers) {
      dataSetter();
    }
    // eslint-disable-next-line
  }, [blockedUsers]);
  useEffect(() => {
    if (values.region !== '') {
      setCities(values.region.cities);
    }
  }, [values.region]);
  return (
    <Page
      title={'Сторінка замовлення'}
      sx={{
        display: 'flex',
        marginTop: '100px',
        marginBottom: '100px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 20px', sm: '0px 20px', md: '0px 50px', lg: '0px 100px' }
      }}
    >
      {stage === 0 ? (
        <>
          {!isLoading ? (
            <Grid
              container
              style={{
                maxWidth: '1440px'
              }}
              spacing={0}
            >
              <Grid item xs={12} sx={{ paddingBottom: '0px' }}>
                <StyledTitle
                  maxWidth={800}
                  sx={{
                    textTransform: 'initial !important',
                    margin: '0px auto 20px !important'
                  }}
                  // className="bottomBlock-title"
                >
                  Оформити замовлення
                </StyledTitle>
              </Grid>
              {/*<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>*/}
              {/*  <Typography*/}
              {/*    variant="subtitle"*/}
              {/*    sx={{*/}
              {/*      display: 'inline-flex',*/}
              {/*      cursor: 'pointer',*/}
              {/*      color: 'black',*/}
              {/*      ':hover': { color: '#60A5DF' }*/}
              {/*    }}*/}
              {/*    onClick={() => navigate(-1)}*/}
              {/*  >*/}
              {/*    <ReplyIcon sx={{ mr: 1, color: 'black' }} />*/}
              {/*    Повернутись на попередню сторінку*/}
              {/*  </Typography>*/}
              {/*</Grid>*/}

              <FormikProvider value={formik}>
                <Form
                  autoComplete="off"
                  noValidate
                  onSubmit={handleSubmit}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '10px',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      maxWidth: '760px'
                    }}
                    // sx={{ paddingBottom: '0px', display: 'flex', flexDirection: 'column' }}
                  >
                    {' '}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        p: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative'
                      }}
                    >
                      {service && (
                        <ServiceCardOrder
                          el={service}
                          qty={values.qty}
                          setter={(value) => {
                            setFieldValue('qty', value);
                            if (
                              value > service?.availableQuantity &&
                              values?.paymentType === 'Безпечна оплата'
                            ) {
                              setFieldValue('paymentType', '');
                            }
                          }}
                        />
                      )}
                      {+values?.qty > +service?.availableQuantity ? (
                        <Typography
                          variant="subtitle"
                          sx={{
                            fontSize: 14,
                            fontFamily: 'FixelText-Regular !important',
                            mb: 0,
                            color: 'red',
                            position: 'absolute',
                            bottom: { xs: '-40px', sm: '-20px' }
                          }}
                        >
                          Ой, товару трохи менше, ніж ви хочете. Після замовлення напишіть продавцю
                          - домовитесь!
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        paddingBottom: '0px',
                        display: 'flex',
                        flexDirection: 'column',
                        pt: { xs: '35px !important', sm: '20px !important', md: '16px' }
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontFamily: 'FixelText-Medium',
                          textAlign: 'left',
                          fontWeight: '500',
                          color: '#1b1b1b'
                        }}
                      >
                        Контактна інформація:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        position: 'relative',
                        mb: 2
                      }}
                    >
                      <CssTextField
                        placeholder="Ім'я*"
                        variant="outlined"
                        fullWidth
                        size="normal"
                        sx={{ marginTop: '0px !important' }}
                        inputProps={{ style: { textAlign: 'left' } }}
                        error={Boolean(touched.buyerName && errors.buyerName)}
                        {...getFieldProps('buyerName')}
                        value={values.buyerName}
                      >
                        {values.buyerName}
                      </CssTextField>
                      {touched.buyerName && errors.buyerName && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '-14px',
                            color: 'red',
                            margin: '0px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {errors.buyerName}
                        </div>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        position: 'relative',
                        mb: 2
                      }}
                    >
                      <CssTextField
                        placeholder="Прізвище*"
                        variant="outlined"
                        fullWidth
                        size="normal"
                        sx={{ marginTop: '0px !important' }}
                        inputProps={{ style: { textAlign: 'left' } }}
                        error={Boolean(touched.buyerSurname && errors.buyerSurname)}
                        {...getFieldProps('buyerSurname')}
                        value={values.buyerSurname}
                      >
                        {values.buyerSurname}
                      </CssTextField>
                      {touched.buyerSurname && errors.buyerSurname && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '-14px',
                            color: 'red',
                            margin: '0px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {errors.buyerSurname}
                        </div>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        position: 'relative',
                        mb: 2
                      }}
                    >
                      <InputMask
                        alwaysShowMask
                        maskChar=""
                        mask="+380999999999"
                        value={values.number}
                        {...getFieldProps('buyerNumber')}
                      >
                        {(inputProps) => (
                          <CssTextField
                            {...inputProps}
                            placeholder="Телефон*"
                            variant="outlined"
                            fullWidth
                            size="normal"
                            sx={{ marginTop: '0px !important' }}
                            inputProps={{ style: { textAlign: 'left' } }}
                            error={Boolean(touched.buyerNumber && errors.buyerNumber)}
                          >
                            {values.buyerNumber}
                          </CssTextField>
                        )}
                      </InputMask>

                      {touched.buyerNumber && errors.buyerNumber && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '-14px',
                            color: 'red',
                            margin: '0px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {errors.buyerNumber}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontFamily: 'FixelText-Medium',

                          textAlign: 'left',
                          fontWeight: '500',
                          color: '#1b1b1b'
                        }}
                      >
                        Доставка:
                      </Typography>
                      <Typography variant="subtitle" sx={{ fontSize: 16, color: '#7C7C7C', mb: 2 }}>
                        Зверніть увагу, що терміни доставки можуть змінюватись.
                      </Typography>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={values.deliveryType}
                          sx={{ position: 'relative' }}
                          onChange={(event) => {
                            setFieldValue('street', '');
                            setFieldValue('houseNumber', '');
                            setFieldValue('region', '');
                            setFieldValue('city', '');
                            setCities([]);
                            setErrors({});
                            setTouched({
                              ...touched,
                              deliveryType: false,
                              department: false,
                              city: false,
                              region: false,
                              street: false,
                              houseNumber: false
                            });
                            setFieldValue('deliveryType', event.target.value);
                          }}
                        >
                          {service?.deliveryOption &&
                            service?.deliveryOption.length !== 0 &&
                            service?.deliveryOption.map((option) => (
                              <FormControlLabel
                                key={option}
                                value={option}
                                control={<Radio />}
                                label={option}
                              />
                            ))}
                          {touched.deliveryType && errors.deliveryType && (
                            <div
                              style={{
                                position: 'absolute',
                                right: '30%',
                                top: '25%',
                                color: 'red',
                                margin: '0px 0px',
                                fontSize: '14px',
                                fontFamily: 'FixelText-Regular'
                              }}
                            >
                              {errors.deliveryType}
                            </div>
                          )}
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{ paddingBottom: '0px', display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontFamily: 'FixelText-Medium',

                          textAlign: 'left',
                          fontWeight: '500',
                          color: '#1b1b1b'
                        }}
                      >
                        Оплата:
                      </Typography>
                      <Typography variant="subtitle" sx={{ fontSize: 16, color: '#7C7C7C', mb: 2 }}>
                        Продавець із вами зв’яжеться.
                      </Typography>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={values.paymentType}
                          onChange={(event) => setFieldValue('paymentType', event.target.value)}
                          sx={{ position: 'relative' }}
                        >
                          {+values?.qty <= +service?.availableQuantity ? (
                            <FormControlLabel
                              disabled={values?.deliveryType !== 'Нова Пошта'}
                              key={'Безпечна оплата через платформу'}
                              value={'Безпечна оплата'}
                              control={<Radio />}
                              label={'Безпечна оплата через платформу'}
                            />
                          ) : null}
                          {service?.paymentOption &&
                            service?.paymentOption.length !== 0 &&
                            service?.paymentOption.map((option) => (
                              <FormControlLabel
                                key={option}
                                value={option}
                                control={<Radio />}
                                label={option}
                              />
                            ))}
                          {touched.paymentType && errors.paymentType && (
                            <div
                              style={{
                                position: 'absolute',
                                right: '30%',
                                top: '25%',
                                color: 'red',
                                margin: '0px 0px',
                                fontSize: '14px',
                                fontFamily: 'FixelText-Regular'
                              }}
                            >
                              {errors.paymentType}
                            </div>
                          )}
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    {/* {values.deliveryType === "Кур'єр" && ( */}
                    <Grid item xs={12} sm={6} sx={{ position: 'relative' }}>
                      <Autocomplete
                        disableClearable
                        options={UACities}
                        // defaultValue={'Україна'}

                        value={values.region}
                        getOptionLabel={(option) => (option?.region ? option?.region : '')}
                        onChange={(event, value) => {
                          setCities(value.cities);
                          setFieldValue('region', value);
                          setFieldValue('city', '');
                          setFieldValue('street', '');
                          setFieldValue('houseNumber', '');
                        }}
                        // inputValue={values.region?.region ? values.region?.region : ''}
                        renderInput={(params) => (
                          <CssTextField
                            {...params}
                            placeholder="Область"
                            variant="outlined"
                            sx={{ mb: '16px' }}
                          />
                        )}
                      />
                      {touched.region && errors.region && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '-12px',
                            color: 'red',
                            margin: '0px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {errors.region}
                        </div>
                      )}
                    </Grid>
                    {/* )} */}
                    <Grid item xs={12} sm={6} sx={{ position: 'relative' }}>
                      <Autocomplete
                        disableClearable
                        disabled={cities.length === 0}
                        options={cities}
                        // defaultValue={'Україна'}

                        value={values.city}
                        onChange={(event, value) => setFieldValue('city', value)}
                        renderInput={(params) => (
                          <CssTextField
                            {...params}
                            placeholder="Населений пункт*"
                            variant="outlined"
                            sx={{ mb: '16px' }}
                          />
                        )}
                      />
                      {touched.city && errors.city && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: values.deliveryType === "Кур'єр" ? '-2px' : '2px',
                            color: 'red',
                            margin: '0px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {errors.city}
                        </div>
                      )}
                    </Grid>
                    {values.deliveryType !== "Кур'єр" ? (
                      <Grid item xs={12} sm={6} sx={{ position: 'relative' }}>
                        {/* <Autocomplete
                            disableClearable
                            disabled={departments.length === 0}
                            options={departments}
                            // defaultValue={'Україна'}
                            sx={{ maxWidth: 300 }}
                            value={values.department}
                            onChange={(event, value) => setFieldValue('department', value)}
                            renderInput={(params) => (
                              <TextField {...params} label="Відділення*" variant="standard" />
                            )}
                          /> */}

                        <CssTextField
                          placeholder="Відділення*"
                          variant="outlined"
                          fullWidth
                          size="normal"
                          sx={{ marginTop: '0px !important', width: '100%', mb: '16px' }}
                          inputProps={{ style: { textAlign: 'left' } }}
                          error={Boolean(touched.department && errors.department)}
                          {...getFieldProps('department')}
                          value={values.department}
                        >
                          {values.department}
                        </CssTextField>
                        {/* {touched.department && errors.department && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '-12px',
                                color: 'red',
                                margin: '0px 0px',
                                fontSize: '14px',

                              }}
                            >
                              {errors.department}
                            </div>
                          )} */}
                        {touched.department && errors.department && (
                          <div
                            style={{
                              position: 'absolute',
                              bottom: '14px',
                              color: 'red',
                              margin: '0px 0px',
                              fontSize: '14px',
                              fontFamily: 'FixelText-Regular'
                            }}
                          >
                            {errors.department}
                          </div>
                        )}
                      </Grid>
                    ) : (
                      <>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            position: 'relative'
                          }}
                        >
                          <CssTextField
                            placeholder="Вулиця*"
                            variant="outlined"
                            fullWidth
                            size="normal"
                            sx={{
                              marginTop: '0px !important',
                              marginBottom: '0px',
                              mb: '16px'
                            }}
                            inputProps={{ style: { textAlign: 'left' } }}
                            error={Boolean(touched.street && errors.street)}
                            {...getFieldProps('street')}
                            value={values.street}
                          >
                            {values.street}
                          </CssTextField>
                          {touched.street && errors.street && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '-2px',
                                color: 'red',
                                margin: '0px 0px',
                                fontSize: '14px',
                                fontFamily: 'FixelText-Regular'
                              }}
                            >
                              {errors.street}
                            </div>
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            position: 'relative'
                          }}
                        >
                          <CssTextField
                            placeholder="Номер будинку*"
                            variant="outlined"
                            fullWidth
                            size="normal"
                            sx={{ marginTop: '0px !important', marginBottom: '16px' }}
                            inputProps={{ style: { textAlign: 'left' } }}
                            error={Boolean(touched.houseNumber && errors.houseNumber)}
                            {...getFieldProps('houseNumber')}
                            value={values.houseNumber}
                          >
                            {values.houseNumber}
                          </CssTextField>
                          {touched.houseNumber && errors.houseNumber && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '-2px',
                                color: 'red',
                                margin: '0px 0px',
                                fontSize: '14px',
                                fontFamily: 'FixelText-Regular'
                              }}
                            >
                              {errors.houseNumber}
                            </div>
                          )}
                        </Grid>
                      </>
                    )}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        paddingBottom: '0px',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative'
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontFamily: 'FixelText-Medium',
                          mb: '16px',
                          textAlign: 'left',
                          fontWeight: '500',
                          color: '#1b1b1b'
                        }}
                      >
                        Коментар до замовлення:
                      </Typography>
                      <CssTextField
                        placeholder="Що хочете написати продавцю?"
                        multiline
                        rows={6}
                        fullWidth
                        inputProps={{ style: { textAlign: 'left' } }}
                        error={Boolean(touched.comment && errors.comment)}
                        {...getFieldProps('comment')}
                        value={values.comment}
                      >
                        {values.comment}
                      </CssTextField>
                      {values.comment.length !== 0 && (
                        <p
                          style={{
                            position: 'absolute',
                            bottom: '-18px',
                            right: 0,
                            margin: '0 5px',
                            color: 'gray',
                            textAlign: 'right',
                            fontSize: '14px'
                          }}
                        >{`${values.comment.length}/150`}</p>
                      )}
                      {touched.comment && errors.comment && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '-18px',
                            color: 'red',
                            margin: '5px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {errors.comment}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
                      <LetsGoBtn3
                        // disabled={Object.keys(errors).length !== 0 || values.city.length === 0}
                        onClick={() => {
                          submitForm();
                        }}
                        text="Замовити"
                        width="255px"
                      />
                    </Grid>
                  </Grid>
                </Form>
              </FormikProvider>
            </Grid>
          ) : (
            <div
              style={{
                // height: '240px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginBottom: '100px',
                height: '100vh'
              }}
            >
              <Spinner />
            </div>
          )}
        </>
      ) : (
        <Grid
          container
          sx={{
            maxWidth: '7600px',
            mt: '20% !important'
          }}
          spacing={3}
        >
          <Grid item xs={12} sx={{ paddingBottom: '0px' }}>
            <StyledTitle
              maxWidth={800}
              sx={{
                textTransform: 'initial !important',
                margin: '0px auto 20px !important'
              }}
            >
              Замовлення прийняте!
            </StyledTitle>
          </Grid>
          <Grid item xs={12} sx={{ mt: 0, display: 'flex', justifyContent: 'center' }}>
            <Typography
              textAlign="center"
              sx={{ maxWidth: '640px', color: '#7C7C7C', fontSize: '20px' }}
            >
              Вітаю! Ваш запит надіслано продавцю. Чекайте на його повідомлення!
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              mt: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: '24px'
            }}
          >
            <LetsGoBtn
              colorScheme="blue"
              disabled={Object.keys(errors).length !== 0 || values.city.length === 0}
              onClick={() => {
                navigate(`/${language}/ribbon`);
              }}
              text="Переглянути цікавеньке"
              width="335px"
            />
            <LetsGoBtn
              colorScheme="white"
              disabled={Object.keys(errors).length !== 0 || values.city.length === 0}
              onClick={() => {
                navigate(`/${language}/user-page/${service?.userDTO?.id}`);
              }}
              text="Інші товари продавця"
              width="335px"
            />
          </Grid>
        </Grid>
      )}
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    blockedUsers: state.global.blockedUsers,
    usersWhoBlocked: state.global.usersWhoBlocked
  };
};
export default connect(mapStateToProps)(OrderPage);
